module.exports = __webpack_public_path__ + "static/media/annet.77b9a161.png";